import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { TaxOnFeeProfileForm } from '../components/TaxOnFeeProfileForm';
interface TaxOnFee {
  id: string;
  code: string;
  name: string;
  taxType: string;
  status: 'active' | 'inactive';
}
export function TaxesOnFeesSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const taxesOnFees: TaxOnFee[] = [{
    id: '1',
    code: 'TOF-001',
    name: 'Service Tax on Processing Fee',
    taxType: 'Service Tax',
    status: 'active'
  }, {
    id: '2',
    code: 'TOF-002',
    name: 'FED on Late Payment Fee',
    taxType: 'FED Tax',
    status: 'active'
  }, {
    id: '3',
    code: 'TOF-003',
    name: 'VAT on Documentation Fee',
    taxType: 'VAT Tax',
    status: 'active'
  }, {
    id: '4',
    code: 'TOF-004',
    name: 'Withholding Tax on Interest',
    taxType: 'Withholding Tax',
    status: 'active'
  }, {
    id: '5',
    code: 'TOF-005',
    name: 'Legacy Service Tax',
    taxType: 'Service Tax',
    status: 'inactive'
  }];
  const filteredTaxes = taxesOnFees.filter(t => t.name.toLowerCase().includes(searchQuery.toLowerCase()) || t.code.toLowerCase().includes(searchQuery.toLowerCase()) || t.taxType.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<TaxOnFee>[] = [{
    key: 'code',
    label: 'Tax Code'
  }, {
    key: 'name',
    label: 'Tax Profile Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-2227">{item.name}</span>
  }, {
    key: 'taxType',
    label: 'Tax Type'
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2228">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2229" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2230" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <TaxOnFeeProfileForm onBack={() => setIsCreating(false)} onSave={() => {
      // In a real app, this would save the data
      setIsCreating(false);
    }} data-id="element-2231" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2232">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2233">
        <div data-id="element-2234">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2235">
            Taxes on Fees
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2236">
            Configure tax profiles for fees with filer/non-filer distinctions.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2237">
          <Plus className="mr-2 h-5 w-5" data-id="element-2238" />
          Add New Taxes on Fee Profile
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2239">
        <div className="relative" data-id="element-2240">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2241" />
          <Input placeholder="Search tax profiles by code, name, or type..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2242" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredTaxes} onRowClick={tax => console.log('Clicked tax:', tax)} keyExtractor={item => item.id} data-id="element-2243" />
    </div>;
}